module.exports = __webpack_public_path__ + "media/images/partner_title-420a47bb5cec7c93f3d3190dba41c4ee.png";